<template>
  <div>
    <global-popup-sms></global-popup-sms>
    <global-recording-manager></global-recording-manager>
  </div>
</template>

<script>

import GlobalPopupSms from '@/layouts/components/popup/SendSms.vue'
import GlobalRecordingManager from '@/layouts/components/popup/GlobalRecordingManager.vue'

export default {
  name: 'Global.Popup',
  components: {
    GlobalPopupSms,
    GlobalRecordingManager
  }
}
</script>
